/*! Yubico Japan — see the commented source in the project repository. */
(function () {
  "use strict";

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var money = window.YUBI_MONEY_FORMAT || "¥{{amount_no_decimals}}";

  function url(path) { return ROOT.replace(/\/$/, "") + path; }

  function formatMoney(cents) {
    var n = (cents / 100);
    var s = n.toLocaleString("ja-JP", { maximumFractionDigits: money.indexOf("no_decimals") > -1 ? 0 : 2 });
    return money.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, s);
  }

  function request(path, body) {
    return fetch(url(path), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || "cart error"); err.status = r.status; throw err; }
        return data;
      });
    });
  }

  function getCart() {
    return fetch(url("/cart.js"), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function lineHtml(l) {
    var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
    var unit = l.quantity ? Math.round(l.final_line_price / l.quantity) : (l.final_price || 0);
    return '' +
      '<div class="cart-line" data-key="' + l.key + '" data-qty="' + l.quantity + '" data-unit="' + unit + '" data-handle="' + escapeHtml(l.handle || "") + '" data-title="' + escapeHtml(l.product_title || "") + '">' +
        '<img class="cart-line__img" src="' + img + '" alt="" width="80" height="80">' +
        '<div style="flex:1">' +
          '<div class="cart-line__name"><a href="' + l.url + '">' + escapeHtml(l.product_title) + '</a></div>' +
          (l.variant_title && l.variant_title !== "Default Title"
            ? '<div class="cart-line__variant muted">' + escapeHtml(l.variant_title) + '</div>' : '') +
          '<div class="cart-line__price">' + formatMoney(l.final_line_price) + ' 税込</div>' +
          '<div class="cart-line__foot">' +
            '<span class="qty">' +
              '<button class="js-cart-dec" data-key="' + l.key + '" aria-label="数量を減らす">−</button>' +
              '<span aria-live="polite">' + l.quantity + '</span>' +
              '<button class="js-cart-inc" data-key="' + l.key + '" aria-label="数量を増やす">+</button>' +
            '</span>' +
            '<button class="cart-line__remove js-cart-remove" data-key="' + l.key + '">削除</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function setCount(n) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      el.textContent = n;
      el.dataset.count = n;
    });
    var title = document.getElementById("cartTitle");
    if (title) title.textContent = "カート（" + n + "点）";
  }

  // Full render — only used on first load or when the set of line-items changes.
  function render(cart) {
    setCount(cart.item_count);

    var body = document.getElementById("cartBody");
    var foot = document.getElementById("cartFoot");
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="drawer__empty"><p>カートは空です。</p>' +
        '<p class="muted">気になる製品を追加してみてください。</p></div>';
      if (foot) foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(lineHtml).join("");

    if (foot) {
      foot.hidden = false;
      var sub = document.getElementById("cartSubtotal");
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
  }

  // Lightweight reconcile — when the line keys are unchanged we only patch the
  // numbers already on screen instead of rebuilding the whole drawer (which
  // reloads every image and thrashes layout). Falls back to full render when
  // the item set changed (add / remove).
  function reconcile(cart) {
    var lines = document.querySelectorAll("#cartBody .cart-line");
    var domKeys = Array.prototype.map.call(lines, function (el) { return el.dataset.key; });
    var cartKeys = cart.items.map(function (l) { return l.key; });
    if (domKeys.length !== cartKeys.length || domKeys.join("|") !== cartKeys.join("|")) {
      render(cart);
      return;
    }
    setCount(cart.item_count);
    cart.items.forEach(function (l, i) {
      var el = lines[i];
      var unit = l.quantity ? Math.round(l.final_line_price / l.quantity) : 0;
      el.dataset.qty = l.quantity;
      el.dataset.unit = unit;
      var span = el.querySelector(".qty span");
      if (span) span.textContent = l.quantity;
      var price = el.querySelector(".cart-line__price");
      if (price) price.textContent = formatMoney(l.final_line_price) + " 税込";
    });
    var sub = document.getElementById("cartSubtotal");
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  // Optimistic subtotal/count straight from what's on screen — instant feedback.
  function paintTotals() {
    var lines = document.querySelectorAll("#cartBody .cart-line");
    var count = 0, subtotal = 0;
    Array.prototype.forEach.call(lines, function (el) {
      var q = parseInt(el.dataset.qty, 10) || 0;
      var u = parseInt(el.dataset.unit, 10) || 0;
      count += q;
      subtotal += q * u;
    });
    setCount(count);
    var sub = document.getElementById("cartSubtotal");
    if (sub) sub.textContent = formatMoney(subtotal);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function refresh() { return getCart().then(render); }

  function openDrawer() {
    var d = document.getElementById("cartDrawer");
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function toast(msg) {
    var t = document.querySelector(".toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      t.setAttribute("role", "status");
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add("is-visible"); });
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("is-visible"); }, 2400);
  }

  function readQty(btn) {
    var id = btn.getAttribute("data-qty-for");
    if (!id) return 1;
    var input = document.getElementById(id);
    var n = parseInt(input && input.value, 10);
    return isFinite(n) ? Math.max(1, n) : 1;
  }

  function addVariant(id, qty, btn) {
    var label = btn && btn.querySelector(".btn__label");
    var prev = label ? label.textContent : null;
    if (btn) btn.classList.add("is-loading");

    return request("/cart/add.js", { items: [{ id: Number(id), quantity: qty }] })
      .then(refresh)
      .then(function () {
        if (btn) {
          btn.classList.remove("is-loading");
          btn.classList.add("is-success");
          if (label) label.textContent = "追加しました";
          setTimeout(function () {
            btn.classList.remove("is-success");
            if (label) label.textContent = prev;
          }, 1400);
        }
        openDrawer();
      })
      .catch(function (err) {
        if (btn) btn.classList.remove("is-loading");

        toast(err.message || "カートに追加できませんでした");
        if (err && err.status === 422) { notifyLimit(id, btn); refresh(); }
      });
  }

  // Coalesced quantity sync — rapid +/- clicks update the UI instantly and only
  // the final target quantity is sent to Shopify (one request per line, not one
  // per click). Prevents the per-click network stall and the lost-increment race.
  var pending = {};      // key -> target quantity
  var timers = {};       // key -> debounce timer
  var inflight = false;

  function scheduleChange(key, qty) {
    pending[key] = qty;
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { flushChange(key); }, 260);
  }

  function flushChange(key) {
    if (inflight) { // serialize; Shopify cart mutations must not overlap
      timers[key] = setTimeout(function () { flushChange(key); }, 120);
      return;
    }
    if (!(key in pending)) return;
    var qty = pending[key];
    delete pending[key];
    delete timers[key];
    inflight = true;
    request("/cart/change.js", { id: key, quantity: qty })
      .then(function (cart) { reconcile(cart); })
      .catch(function (err) {
        toast(err.message || "数量を変更できませんでした");
        if (err && err.status === 422) notifyLineLimit(key);
        return refresh(); // restore authoritative state on failure
      })
      .then(function () {
        inflight = false;
        // If more clicks queued while this was in flight, flush them now.
        for (var k in pending) { flushChange(k); break; }
      });
  }

  // Requested qty > available stock (Shopify 422): let back-in-stock.js open the restock form.
  function notifyLimit(id, btn) {
    try { document.dispatchEvent(new CustomEvent("yubi:stock-limit", { detail: { variantId: String(id), button: btn || null } })); } catch (_) {}
  }

  // Cart drawer +/- exceeded stock: open the drawer restock form for that line's product.
  function notifyLineLimit(key) {
    try {
      var lines = document.querySelectorAll("#cartBody .cart-line"), line = null;
      for (var i = 0; i < lines.length; i++) { if (lines[i].getAttribute("data-key") === key) { line = lines[i]; break; } }
      document.dispatchEvent(new CustomEvent("yubi:stock-limit", { detail: {
        drawer: true,
        handle: line ? line.getAttribute("data-handle") : "",
        title: line ? line.getAttribute("data-title") : ""
      } }));
    } catch (_) {}
  }

  // 今すぐ購入 (buy now): add the variant, then go straight to checkout.
  function buyNow(id, qty, btn) {
    if (btn) btn.classList.add("is-loading");
    return request("/cart/add.js", { items: [{ id: Number(id), quantity: qty }] })
      .then(function () { window.location.href = "/checkout"; })
      .catch(function (err) {
        if (btn) btn.classList.remove("is-loading");
        toast(err.message || "購入手続きに進めませんでした");
        if (err && err.status === 422) { notifyLimit(id, btn); refresh(); }
      });
  }

  document.addEventListener("click", function (e) {
    var buy = e.target.closest("[data-buy-now]");
    if (buy) {
      e.preventDefault();
      if (buy.classList.contains("is-loading") || buy.hasAttribute("disabled")) return;
      buyNow(buy.getAttribute("data-buy-now"), readQty(buy), buy);
      return;
    }
    var add = e.target.closest("[data-variant-id]");
    if (add) {
      e.preventDefault();
      if (add.classList.contains("is-loading")) return;
      addVariant(add.getAttribute("data-variant-id"), readQty(add), add);
      return;
    }
    var inc = e.target.closest(".js-cart-inc");
    var dec = e.target.closest(".js-cart-dec");
    var rem = e.target.closest(".js-cart-remove");
    if (inc || dec || rem) {
      e.preventDefault();
      var el = inc || dec || rem;
      var line = el.closest(".cart-line");
      if (!line) return;
      var key = el.getAttribute("data-key");
      var current = parseInt(line.dataset.qty, 10);
      if (!isFinite(current)) current = parseInt(line.querySelector(".qty span").textContent, 10) || 0;
      var next = rem ? 0 : Math.max(0, current + (inc ? 1 : -1));

      if (next <= 0) {
        // Optimistically drop the line, then sync.
        line.remove();
        if (rem) toast("カートから削除しました");
        if (!document.querySelector("#cartBody .cart-line")) {
          // Was the last item — render empty state immediately.
          render({ item_count: 0, items: [], total_price: 0 });
        } else {
          paintTotals();
        }
        scheduleChange(key, 0);
        return;
      }

      // Optimistic in-place update — instant, no network wait, no re-render.
      line.dataset.qty = next;
      var span = line.querySelector(".qty span");
      if (span) span.textContent = next;
      var unit = parseInt(line.dataset.unit, 10) || 0;
      var price = line.querySelector(".cart-line__price");
      if (price) price.textContent = formatMoney(unit * next) + " 税込";
      paintTotals();
      scheduleChange(key, next);
    }
  });

  function changeLine(key, quantity) {
    return request("/cart/change.js", { id: key, quantity: quantity })
      .then(reconcile)
      .catch(function (err) { toast(err.message || "数量を変更できませんでした"); });
  }

  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh(); });

  if (document.readyState !== "loading") refresh();
  else document.addEventListener("DOMContentLoaded", refresh);

  window.YubiCart = { refresh: refresh, add: addVariant, change: changeLine, get: getCart };
})();
